import React, { useState, useEffect } from 'react';
import { Button, Input, Table, message, Modal } from 'antd';
import useWebPost from '../utils/useWebPost';
import { formatDate2, formatDate, formatDateTime, parseToTimestamp, preprocessQuotedFields } from '../utils/functions'
import CustModal from './ShowModal';
import QuestionHelp from './QuestionHelp';

const PARSER_CONFIGS = {
    account_info: {
        columns: [
            { title: '序号', dataIndex: 'xd', key: 'xd' },
            { title: '名称', dataIndex: 'name', key: 'name' },
            { title: '登入渠道', dataIndex: 'login_channel', key: 'login_channel' },
            { title: '登入网址', dataIndex: 'login_url', key: 'login_url' },
            { title: '登录账号', dataIndex: 'login_account', key: 'login_account' },
            { title: '登录密码', dataIndex: 'login_password', key: 'login_password' },
            { title: '注册手机', dataIndex: 'register_phone', key: 'register_phone' },
            { title: '注册邮箱', dataIndex: 'register_email', key: 'register_email' },
            { title: '用户名称', dataIndex: 'user_name', key: 'user_name' },
            { title: 'CA锁', dataIndex: 'ca_lock', key: 'ca_lock' },
            { title: '归档序号', dataIndex: 'archive_number', key: 'archive_number' },
            { title: 'CA保管单位', dataIndex: 'ca_keeper_unit', key: 'ca_keeper_unit' },
            { title: '办理时间', dataIndex: 'handling_time', key: 'handling_time' },
            { title: '有效期', dataIndex: 'validity_period', key: 'validity_period' },
            { title: '使用情况', dataIndex: 'usage_status', key: 'usage_status' },
            { title: '备注', dataIndex: 'remarks', key: 'remarks' },
            { title: '经办人/电话', dataIndex: 'handler_info', key: 'handler_info' },
        ],
        requiredFields: ['name'],
        staticValues: { type: '$type$' },
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate2(parseToTimestamp(c));
                }
                row[key] = c;
            }
            return row;
        },
        // 
        fieldOrder: ['xd', 'name', 'login_channel', 'login_url', 'login_account', 'login_password', 'register_phone', 'register_email', 'user_name',
            'ca_lock', 'archive_number', 'ca_keeper_unit', 'handling_time', 'validity_period', 'usage_status', 'remarks', 'handler_info'],
    },
    account_info2: {
        columns: [
            { title: '序号', dataIndex: 'xd', key: 'xd' },
            { title: '名称', dataIndex: 'name', key: 'name' },
            { title: '登入渠道', dataIndex: 'login_channel', key: 'login_channel' },
            { title: '使用人', dataIndex: 'login_url', key: 'login_url' },
            { title: '注册手机', dataIndex: 'register_phone', key: 'register_phone' },
            { title: '登录账号', dataIndex: 'login_account', key: 'login_account' },
            { title: '登录密码', dataIndex: 'login_password', key: 'login_password' },
            { title: '有效期', dataIndex: 'validity_period', key: 'validity_period' },
            { title: '使用情况', dataIndex: 'usage_status', key: 'usage_status' },
            { title: '其它', dataIndex: 'handler_info', key: 'handler_info' },
            { title: '备注', dataIndex: 'remarks', key: 'remarks' },
        ],
        requiredFields: ['name'],
        staticValues: {},
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate2(parseToTimestamp(c));
                }
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['xd', 'name', 'login_channel', 'login_url', 'register_phone', 'login_account', 'login_password', 'validity_period', 'usage_status', 'handler_info', 'remarks'],
    },
    cwjxpjl: {
        columns: [
            { title: '时间', dataIndex: 'ptime', key: 'ptime' },
            { title: '名称', dataIndex: 'mc', key: 'mc' },
            { title: '发票种类', dataIndex: 'zl', key: 'zl' },
            { title: '税率', dataIndex: 'sl', key: 'sl' },
            { title: '不含税价', dataIndex: 'amount', key: 'amount' },
            { title: '税金', dataIndex: 'sj', key: 'sj' },
            { title: '开票金额合计', dataIndex: 'kpj', key: 'kpj' },
            { title: '票号', dataIndex: 'ph', key: 'ph' },
            { title: '抵扣说明', dataIndex: 'dk', key: 'dk' },
        ],
        // 必需字段（用于校验）
        requiredFields: ['kpj'],
        // 固定值（每条记录都加上）
        staticValues: {
            oid: '$oid$'
        },
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } else {
                    if (key === 'sl') c = c.replace('%', '');
                }
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['ptime', 'mc', 'zl', 'sl', 'amount', 'sj', 'kpj', 'ph', 'dk'],
    },
    cwxxpjl: {
        columns: [
            { title: '时间', dataIndex: 'ptime', key: 'ptime' },
            { title: '名称', dataIndex: 'mc', key: 'mc' },
            { title: '发票种类', dataIndex: 'zl', key: 'zl' },
            { title: '税率', dataIndex: 'sl', key: 'sl' },
            { title: '不含税价', dataIndex: 'amount', key: 'amount' },
            { title: '税金', dataIndex: 'sj', key: 'sj' },
            { title: '开票金额合计', dataIndex: 'kpj', key: 'kpj' },
            { title: '票号', dataIndex: 'ph', key: 'ph' },
            { title: '备注', dataIndex: 'dk', key: 'dk' },
        ],
        // 必需字段（用于校验）
        requiredFields: ['kpj'],
        // 固定值（每条记录都加上）
        staticValues: {
            oid: '$oid$'
        },
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } else {
                    if (key === 'sl') c = c.replace('%', '');
                    if (key === 'zl') c = c ? c : '专票';
                }
                row[key] = c;
            }
            return row;
        },
        // fieldOrder: ['ptime', 'mc', 'sl', 'amount', 'sj', 'kpj', 'ph','dk' ,'zl'],
        fieldOrder: ['ptime', 'mc', 'zl', 'sl', 'amount', 'sj', 'kpj', 'ph', 'dk'],
    },
    zbxmb: {
        columns: [
            {
                title: '项目名称',
                dataIndex: 'xmmc',
                width: 240,
                fixed: 'left',
                key: 'xmmc'
            },
            {
                title: '招标单位',
                width: 240,
                dataIndex: 'bh4',
                key: 'bh4',
            },
            {
                title: '中标价(元)',
                width: 140,
                dataIndex: 'zy',
                key: 'zy'
            },
            {
                title: '投标保证金(元)',
                width: 140,
                dataIndex: 'tbbzj',
                key: 'tbbzj'
            },
            {
                title: '工期(天)',
                dataIndex: 'zl',
                width: 100,
                key: 'zl'
            },
            {
                title: '项目经理',
                dataIndex: 'xm',
                width: 120,
                key: 'xm'
            },
            {
                title: '中标或合同签订日期',
                dataIndex: 'rq1',
                width: 120,
                key: 'rq1',
            },
            {
                title: '客户姓名',
                dataIndex: 'khxm',
                width: 120,
                key: 'khxm'
            },
            {
                title: '管理费率(%)',
                dataIndex: 'glf',
                width: 120,
                key: 'glf'
            },
            {
                title: '业绩归属',
                dataIndex: 'ywname',
                width: 120,
                key: 'ywname'
            },
            {
                title: '备注',
                dataIndex: 'ps',
                width: 120,
                key: 'ps'
            },
            {
                title: '会审资料',
                width: 120,
                dataIndex: 'bh2',
                key: 'bh2',
            },
            {
                title: '合同原件',
                width: 120,
                dataIndex: 'bh3',
                key: 'bh3',
            },
            {
                title: '业绩录入',
                width: 120,
                dataIndex: 'bh5',
                key: 'bh5',
            },
        ],
        // 必需字段（用于校验）
        requiredFields: ['xmmc'],
        staticValues: {},
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } else {
                    if (key === 'zy') c = c * 10000 || 0;
                    if (key === 'tbbzj') c = c * 10000 || 0;
                }
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['xmmc', 'bh4', 'zy', 'tbbzj', 'zl', 'xm', 'rq1', 'khxm', 'glf', 'ywname', 'ps', 'bh2', 'bh3', 'bh5'],
    },
    zbxmb2: {
        columns: [
            {
                title: '合同编号',
                dataIndex: 'bh',
                modtype: 'text',
                width: 120,
                key: 'bh'
            },
            {
                title: '项目名称',
                modtype: 'text',
                dataIndex: 'xmmc',
                width: 240,
                key: 'xmmc'
            },
            {
                title: '中标或合同签订日期',
                modtype: 'date',
                dataIndex: 'rq1',
                width: 140,
                key: 'rq1',
            },
            {
                title: '工期(天)',
                modtype: 'text',
                dataIndex: 'zl',
                width: 90,
                key: 'zl'
            },
            {
                title: '项目经理',
                modtype: 'text',
                dataIndex: 'xm',
                width: 100,
                key: 'xm'
            },
            {
                title: '公示到期时间/完工时间',
                modtype: 'date',
                dataIndex: 'rq2',
                key: 'rq2', width: 160,
            },
            {
                title: '中标价(元)',
                modtype: 'text',
                dataIndex: 'zy',
                width: 120,
                key: 'zy'
            },
            {
                title: '项目类型',
                modtype: 'text',
                dataIndex: 'bh2',
                width: 120,
                key: 'bh2',
            },
            {
                title: '中标通知书、合同、验收报告、发票',
                modtype: 'text',
                dataIndex: 'bh3',
                width: 240,
                key: 'bh3',
            },
            {
                title: '招标单位',
                modtype: 'text',
                dataIndex: 'bh4',
                width: 240,
                key: 'bh4',
            },
            {
                title: '中标公示网址',
                modtype: 'text',
                dataIndex: 'bh5',
                width: 160,
                key: 'bh5',
            }
        ],
        // 必需字段（用于校验）
        requiredFields: ['xmmc'],
        staticValues: {},
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } else {
                    if (key === 'tbbzj') c = c * 10000 || 0;
                }
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['bh', 'xmmc', 'rq1', 'zl', 'xm', 'rq2', 'zy', 'bh2', 'bh3', 'bh4', 'bh5'],
    },
    hr_resource: {
        columns: [
            { title: '姓名', dataIndex: 'name', width: 120 },
            { title: '性别', dataIndex: 'gender', width: 80 },
            { title: '年龄', dataIndex: 'age', width: 80 },
            { title: '职务、工种', dataIndex: 'job', width: 150 },
            { title: '学历', dataIndex: 'education', width: 120 },
            { title: '身份证号码', dataIndex: 'id_card', width: 180 },
            { title: '联系电话', dataIndex: 'phone', width: 130 },
            { title: '住址', dataIndex: 'address', width: 200 },
            { title: '入职日期', dataIndex: 'entry_date', width: 120 },
            { title: '职业证书名称', dataIndex: 'certificate_name', width: 180 },
            { title: '附件', dataIndex: 'files', width: 200, },
            { title: '状态', dataIndex: 'status', width: 100 },
            { title: '是否隐藏', dataIndex: 'is_hidden', width: 100 },
            { title: '备注', dataIndex: 'remark', width: 140 }
        ],
        requiredFields: ['name'],
        staticValues: {},
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } 
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['name', 'gender', 'age', 'job', 'education', 'id_card', 'phone', 'address', 'entry_date', 'certificate_name','files','status','is_hidden','remark'],
    },
    zjxmjl: {
        columns: [
            {
                title: '姓名',
                dataIndex: 'xm',
                width: 120,
                key: 'xm',
                fixed: 'left'
            },
            {
                title: '专业',
                dataIndex: 'zy',
                width: 120,
                key: 'zy',
                fixed: 'left'
            },
            {
                title: '是否在建',
                dataIndex: 'iszj',
                width: 120,
                key: 'iszj',
                render: (_, record) => {
                    if (record.iszj - 1 == 0) return <div style={{ 'color': 'red' }}>在建</div>
                }
            },
            {
                title: '项目名称',
                dataIndex: 'xmmc',
                width: 240,
                key: 'xmmc'
            },
            {
                title: '工期',
                dataIndex: 'gq',
                width: 120,
                key: 'gq'
            },
            {
                title: '开标日期',
                dataIndex: 'kbrq',
                width: 120,
                key: 'kbrq',
                render: (_, record) => {
                    if (record.kbrq > 100000) {
                        return formatDateTime(record.kbrq);
                    } else {
                        return '';
                    }
                }
            },
            {
                title: '是否中标',
                dataIndex: 'zb',
                width: 120,
                key: 'zb'
            },
            {
                title: '合同日期',
                dataIndex: 'htrq',
                width: 120,
                key: 'htrq',
                render: (_, record) => {
                    if (record.htrq > 1000) {
                        return formatDateTime(record.htrq);
                    } else {
                        return '无'
                    }
                }
            },
            {
                title: '备注',
                dataIndex: 'ps',
                width: 120,
                key: 'ps'
            },
            {
                title: '备注2',
                dataIndex: 'ps1',
                width: 120,
                key: 'ps1'
            },
        ],
        // 必需字段（用于校验）
        requiredFields: ['xm'],
        staticValues: {},
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } else {
                    if (key === 'iszj') c = c ? 1 : 0;
                }
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['xm', 'zy', 'iszj', 'xmmc', 'gq', 'kbrq', 'zb', 'htrq', 'ps', 'ps1'],
    },
    cwtz: {
        columns: [
            {
                title: '日期',
                dataIndex: 'ptime',
                width: 120,
                key: 'ptime',
            },
            {
                title: '金额',
                dataIndex: 'amount',
                width: 120,
                key: 'amount',
            },
            {
                title: '备注',
                dataIndex: 'ps',
                width: 120,
                key: 'ps',
            },
            {
                title: '用途',
                dataIndex: 'yt',
                width: 240,
                key: 'yt'
            },

        ],
        // 必需字段（用于校验）
        requiredFields: ['amount'],
        staticValues: {},
        transformRow: (row) => {
            for (const [key, value] of Object.entries(row)) {
                let c = (value || '').toString().trim();
                if (isDateField(key)) {
                    c = formatDate(parseToTimestamp(c));
                } else {
                    if (key === 'iszj') c = c ? 1 : 0;
                }
                row[key] = c;
            }
            return row;
        },
        fieldOrder: ['ptime', 'amount', 'ps', 'yt'],
    },
};
const DATE_FIELD_KEYWORDS = ['ptime', 'rq1', 'rq2', 'rq3', 'rq4', 'rq5', 'kbrq', 'date', 'htrq', 'created', 'updated',
    'starttime', 'sh1time', 'handling_time', 'validity_period','entry_date'];

function isDateField(fieldName) {
    const lower = fieldName.toLowerCase();
    return DATE_FIELD_KEYWORDS.some(kw => lower.includes(kw));
}
function isNumField(fieldName) {
    const lower = fieldName.toLowerCase();
    return ['amount', 'sl', 'sj', 'kpj'].some(kw => lower.includes(kw));
}

const ProjectImport = ({ Dbname, otherParams = {}, onSave, visible = false, onClose, onSaveSuccess }) => {
    const webPost = useWebPost();
    const [rawText, setRawText] = useState('');
    const [parsedData, setParsedData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(false);

    let mytbs = Dbname;
    if (Dbname === 'account_info') {
        if (otherParams.type === '5' || otherParams.type === '6') {
            mytbs += '2';
        }
    }
    const config = PARSER_CONFIGS[mytbs] || {};

    // 初始化列
    useEffect(() => {
        setColumns(config.columns || []);
    }, [Dbname]);
    const parseData = () => {
        if (!config?.fieldOrder || config.fieldOrder.length === 0) {
            message.error('配置错误：未设置fieldOrder字段顺序');
            return;
        }
        const fixedColCount = config.fieldOrder.length;

        const cleanedText = preprocessQuotedFields(rawText);

        // 现在可以安全地按换行拆行（因为单元格内换行已被替换）
        const rawRows = cleanedText.split(/\r\n|\n|\r/).map(line => line.trim());
        const validRawRows = rawRows.filter(line => line !== '');

        if (validRawRows.length === 0) {
            message.error('请输入数据');
            return;
        }

        const rows = [];
        for (const rowStr of validRawRows) {
            // 此时 rowStr 中已无引号，且无单元格内换行/\t
            let cells = rowStr.split('\t');

            // 仍做一次 trim（防御性）
            cells = cells.map(cell => cell.trim());

            // 对齐列数
            const processedCells = [];
            for (let i = 0; i < fixedColCount; i++) {
                processedCells.push(cells[i] ?? '');
            }

            if (!processedCells.every(cell => cell === '')) {
                rows.push(processedCells);
            }
        }

        if (rows.length === 0) {
            message.error('未解析到有效数据行');
            return;
        }

        // 步骤4：按fieldOrder映射字段（固定列顺序）
        const results = [];
        for (let lineIdx = 0; lineIdx < rows.length; lineIdx++) {
            const cells = rows[lineIdx];
            const row = {};

            // 严格按fieldOrder映射，空单元格对应''
            config.fieldOrder.forEach((key, idx) => {
                row[key] = cells[idx] || '';
            });

            // 添加静态字段
            Object.assign(row, config.staticValues || {});

            // 自定义转换
            if (typeof config.transformRow === 'function') {
                config.transformRow(row);
            }

            // 校验必填字段
            let valid = true;
            for (const key of config.requiredFields || []) {
                if (!row[key]) {
                    message.error(`第 ${lineIdx + 1} 行缺少必填字段：${key}`);
                    valid = false;
                    break;
                }
            }
            if (!valid) return;

            results.push(row);
        }

        setParsedData(results);
        message.success(`成功解析 ${results.length} 条有效记录（共识别 ${rows.length} 行数据）`);
    };
    const parseData2 = () => {
        const lines = rawText
            .split('\n')
            .map(line => line.trim())
            .filter(line => line);

        if (lines.length === 0) {
            message.error('请输入数据');
            return;
        }

        let headers = [];
        let hasHeader = false;

        // 尝试检测是否存在表头
        let headerline = 0
        for (let i = 0; i < Math.min(2, lines.length); i++) {
            const headerMatchCount = config.columns.filter(col => lines[i].includes(col.title)).length;
            if (headerMatchCount > 0) {
                hasHeader = true;
                headers = lines[i].split('\t').map(h => h.trim());
                headerline++;
                break;
            }
        }
        const dataLines = hasHeader ? lines.slice(headerline) : lines;
        // 构建列索引映射
        const colIndexMap = {};
        if (hasHeader) {
            headers.forEach((header, idx) => {
                colIndexMap[header] = idx;
            });
        } else {
            // 无表头：按顺序对应字段
            (config.fieldOrder || []).forEach((key, idx) => {
                colIndexMap[key] = idx;
            });
        }
        // 自动生成 fieldMap: dataIndex → title
        const fieldMap = {};
        config.columns.forEach(col => {
            if (col.dataIndex && col.title) {
                fieldMap[col.dataIndex] = col.title;
            }
        });
        const results = [];
        for (let line of dataLines) {
            const cells = line.split('\t').map(c => c.trim());
            while (cells.length < (hasHeader ? headers.length : (config.fieldOrder?.length || 0))) {
                cells.push('');
            }
            const row = {};
            // 填充字段
            if (hasHeader) {
                for (const [dataKey, headerName] of Object.entries(fieldMap || {})) {
                    const idx = colIndexMap[headerName];
                    row[dataKey] = idx !== undefined ? cells[idx] : '';
                }
            } else {
                // 无表头：按顺序
                (config.fieldOrder || []).forEach((key, idx) => {
                    row[key] = cells[idx] || '';
                });
            }
            // 添加静态字段
            Object.assign(row, config.staticValues || {});

            // 自定义转换
            if (typeof config.transformRow === 'function') {
                config.transformRow(row);
            }

            // 校验必填（针对 dataIndex 键）
            let valid = true;
            for (const key of config.requiredFields || []) {
                if (!row[key]) {
                    message.error(`第 ${results.length + 1} 行缺少字段：${key}`);
                    valid = false;
                    break;
                }
            }
            if (!valid) return;

            results.push(row);
        }

        setParsedData(results);
        message.success(`成功解析 ${results.length} 条记录`);
    };

    const handleSubmit = async () => {
        if (parsedData.length === 0) {
            message.warning('请先解析数据');
            return;
        }
        const formattedData = parsedData.map(row => {
            const newRow = { ...row }; // 浅拷贝（如果 row 是扁平对象，足够）
            for (const [key, value] of Object.entries(newRow)) {
                let c = (value || '').toString().trim();
                if (key == 'xd') continue;
                if (key == 'oid') {
                    c = otherParams.oid;
                }
                if (key == 'type') {
                    c = otherParams.type;
                }
                if (isDateField(key)) {
                    // c = parseToTimestamp(c);
                } else if (isNumField(key)) {
                    c = Number(c) || 0;
                }
                newRow[key] = c;
            }
            return newRow;
        });
        setLoading(true);
        try {
            console.log('要提交记录了', formattedData);
            // return;
            const response = await webPost('sysipt', { tbn: Dbname, data: formattedData });
            if (response) {
                setRawText('');
                setParsedData([]);
                if (onSave) onSave();
            } else {
                alert('导入失败');
            }
        } catch (error) {
            console.error('提交失败:', error);
            message.error('保存失败：' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustModal
            title="批量导入"
            open={visible}
            onCancel={onClose}
            footer={null}
            width="80vw"
            help={
                <ol>
                    <li>使用时注意格式，不要复制表头</li>
                    <li>注意复制的内容必须和列表中展示的顺序一致</li>
                    <li>复制完成后解析数据，注意观察解析后的表格是否匹配，避免列不匹配导致错行错列</li>
                    <li>确认无误后，点击提交到服务器</li>
                </ol>
            }
            showFo
        >

            <h2>批量导入项目数据，excel格式请严格按照下表结构</h2>

            <Input.TextArea
                rows={12}
                value={rawText}
                onChange={(e) => setRawText(e.target.value)}
                placeholder={`粘贴你的数据...`}
                style={{ marginBottom: 16 }}
            />

            <Button type="primary" onClick={parseData} style={{ marginRight: 8 }}>
                解析数据
            </Button>
            <div style={{
                width: '100%',
                overflow: 'auto',
                border: '1px solid #f0f0f0',
                borderRadius: '6px'
            }}>
                <Table
                    dataSource={parsedData}
                    columns={columns}
                    rowKey={(r, i) => i}
                    pagination={{ pageSize: 50 }}
                    style={{ minWidth: '100%', marginBottom: 16 }}
                    scroll={{
                        x: 1800,
                    }}
                    tableLayout="fixed"
                />
            </div>
            {parsedData.length > 0 && (
                <>
                    <Button type="primary" loading={loading} onClick={handleSubmit}>
                        提交到服务器
                    </Button>
                </>
            )}

        </CustModal>
    );
};

export default ProjectImport;